import React from 'react'
import styled from 'styled-components'
import Image from 'components/Common/Image'
import { rem } from 'polished'
import noop from 'lib/function/noop'
import Clickable from 'components/Common/Clickable'
import cn from 'clsx'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { mediaHoverable } from 'lib/theme/mediaQueries'

const ImageButton = styled(Clickable)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  isolation: isolate;
  height: ${rem(80)};
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
  border-radius: ${props => props.theme.borderRadius.S};
  overflow: hidden;

  ${mediaHoverable} {
    &:hover {
      box-shadow: inset 0px 0px 0px 1px ${props => props.theme.palette.neutral.default.one};
    }
  }

  &.selected {
    box-shadow: inset 0px 0px 0px 2px ${props => props.theme.palette.neutral.default.one};
  }

  &.quick-filter-item {
    width: ${rem(110)};
  }

  ${mediaQueryUp.desktop} {
    height: ${rem(100)};

    &.quick-filter-item {
      width: auto;
    }
  }
`

interface Props {
  onClick?: (cruiseLine: string) => void
  cruiseLine: App.CruiseSearchFacet
  isSelected?: boolean
  to?: string;
  isQuickFilter?: boolean;
}

function CruiseLinesSectionItem(props: Props) {
  const { to, cruiseLine, isSelected, onClick = noop, isQuickFilter } = props
  return (
    <ImageButton
      onClick={() => onClick(cruiseLine.value)}
      to={to}
      className={cn({
        'quick-filter-item': isQuickFilter,
        selected: isSelected,
      })}
    >
      <Image
        id={cruiseLine.imageId}
        alt={cruiseLine.name}
        style={{
          width: '100%',
          padding: 16,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      />
    </ImageButton>
  )
}

export default CruiseLinesSectionItem
